
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Options, Vue } from "vue-class-component";

import HotspotContentList from "@/components/Common/HotspotContentList.vue";

@Options({
  components: {
    HotspotContentList,
  },
  props: {
    modules: Object,
  },
  created() {
    // console.log(this.modules, "进来了");
  },
  data() {
    return {
      currentNav: 0,
    };
  },
  inject: ["outsideIframeShow"],
  methods: {
    audiobgstop() {
      this.$emit("audiobgstop");
    },
    goZsPage() {
      this.$storage.goZsAppPage(this, 1);
    },
    click(k: number) {
      this.currentNav = k;
    },
  },
})
export default class Hotspot6 extends Vue {}
